"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressMatchOptionsV1$ = exports.AddressMatchOptionsV1$outboundSchema = exports.AddressMatchOptionsV1$inboundSchema = void 0;
exports.addressMatchOptionsV1ToJSON = addressMatchOptionsV1ToJSON;
exports.addressMatchOptionsV1FromJSON = addressMatchOptionsV1FromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.AddressMatchOptionsV1$inboundSchema = z.object({
    barcoder_version: z.literal("V1").default("V1").optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "barcoder_version": "barcoderVersion",
    });
});
/** @internal */
exports.AddressMatchOptionsV1$outboundSchema = z.object({
    barcoderVersion: z.literal("V1").default("V1"),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        barcoderVersion: "barcoder_version",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AddressMatchOptionsV1$;
(function (AddressMatchOptionsV1$) {
    /** @deprecated use `AddressMatchOptionsV1$inboundSchema` instead. */
    AddressMatchOptionsV1$.inboundSchema = exports.AddressMatchOptionsV1$inboundSchema;
    /** @deprecated use `AddressMatchOptionsV1$outboundSchema` instead. */
    AddressMatchOptionsV1$.outboundSchema = exports.AddressMatchOptionsV1$outboundSchema;
})(AddressMatchOptionsV1$ || (exports.AddressMatchOptionsV1$ = AddressMatchOptionsV1$ = {}));
function addressMatchOptionsV1ToJSON(addressMatchOptionsV1) {
    return JSON.stringify(exports.AddressMatchOptionsV1$outboundSchema.parse(addressMatchOptionsV1));
}
function addressMatchOptionsV1FromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AddressMatchOptionsV1$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AddressMatchOptionsV1' from JSON`);
}
//# sourceMappingURL=addressmatchoptionsv1.js.map